import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { Container, Row } from "~/styles/Elements"
import GithubLogo from "~/icons/github-logo.svg"

interface IProps {
  siteTitle: string
  location: string
}

const Header:React.SFC<IProps> = ({ siteTitle }) => {

  return (
    <HeaderEl>
      <Container>
        <Row>
          <h1 style={{ margin: 0 }}>
            <Link
              to="/"
              style={{
                color: `white`,
                textDecoration: `none`,
              }}
            >
              {siteTitle}
            </Link>
          </h1>
          <ImageLink href="https://github.com/u12206050/react-gutenberg" title="Open repository" target="_blank"><img src={GithubLogo} alt="Github Logo" /></ImageLink>
        </Row>
      </Container>
    </HeaderEl>
  )
}

const HeaderEl = styled.header`
  background: royalblue;
  marginBottom: 1.45rem;
`

const ImageLink = styled.a`
  line-height: 1;
  padding: 0 1em;
  margin: 0;

  img {
    width: 2rem;
  }
`

export default Header
